<template>
  <div>
    <h1 class="ya-te-page-title mb-[3.75rem] mt-5 text-center font-bold leading-none md:mb-20">
      プライバシーポリシー
    </h1>
    <div class="w-full">
      <div class="mb-10">
        <h3 class="co-display-11 mb-5 font-bold">
          はじめに
        </h3>
        <p class="mb-4 ml-4 leading-loose">
          当社は、本サービスを利用する全ての方（以下「利用者」といいます）のプライバシーを尊重するために、 利用者の個人情報を以下の定義に従い、個人情報の適切な取り扱いに取り組んでまいります。
        </p>
      </div>
      <div class="mb-10">
        <h3 class="co-display-11 mb-5 font-bold">
          個人情報の定義
        </h3>
        <p class="mb-4 ml-4 leading-loose">
          個人情報とは、本サービスを通じて利用者から取得する氏名、メールアドレス、電話番号その他の利用者個人を特定できる情報のことを指します。収集する個人情報は、利用者から本サービスにてご登録いただく情報及び利用者の本サービスへのアクセスログです。
        </p>
      </div>
      <div class="mb-10">
        <h3 class="co-display-11 mb-5 font-bold">
          個人情報の利用目的について
        </h3>
        <p class="mb-4 ml-4 leading-loose">
          当社は、利用者の個人情報を以下の目的で利用することができるものとします。
        </p>
        <ol class="my-5 ml-4 list-decimal pl-7">
          <li class="mb-2">
            本サービスならびにその他本サービスに関連する情報の提供のため
          </li>
          <li class="mb-2">
            利用者の本人確認のため
          </li>
          <li class="mb-2">
            本サービスの運営上必要な事項の通知（電子メールによるものを含むものとします。）
          </li>
          <li class="mb-2">
            当社及び第三者の商品等の広告または宣伝（電子メールによるものを含むものとします。）
          </li>
          <li class="mb-2">
            メールマガジンの送信
          </li>
          <li class="mb-2">
            個人を特定できない範囲においての統計情報の作成および利用
          </li>
          <li class="mb-2">
            本サービスの改善や新規開発に必要なデータの解析や分析
          </li>
          <li class="mb-2">
            利用者の皆様の行動、性別、本サービス内でのアクセス履歴などを用いたターゲティング広告の配信
          </li>
          <li class="mb-2">
            契約や法律等に基づく権利の行使や義務の履行
          </li>
          <li class="mb-2">
            アフターサービス、各種問い合わせ対応のため
          </li>
        </ol>
      </div>
      <div class="mb-10">
        <h3 class="co-display-11 mb-5 font-bold">
          個人情報の共有ならびに利用制限について
        </h3>
        <p class="mb-4 ml-4 leading-loose">
          当社は、以下に定める場合、個人情報を第三者に提供します。<br>以下を除いて、事前に利用者本人の同意を得ず、利用目的の達成に必要な範囲を超えて個人情報を利用または共有することはありません。
        </p>
        <ol class="my-5 ml-4 list-decimal pl-7">
          <li class="mb-2">
            利用目的の達成のために講師またはインストラクターに個人情報が提供される場合
          </li>
          <li class="mb-2">
            当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部または一部を委託する場合
          </li>
          <li class="mb-2">
            合併、会社分割、事業譲渡その他の事由による事業の承継に伴って個人情報が提供される場合
          </li>
          <li class="mb-2">
            情報収集モジュール提供者へ個人情報が提供される場合
          </li>
          <li class="mb-2">
            国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、ユーザーの同意を得ることによって当該事務の遂行に支障を及ぼすおそれがある場合
          </li>
          <li class="mb-2">
            ユーザーの事前の同意がある場合
          </li>
          <li class="mb-2">
            利用者の皆様の同意があった場合
          </li>
          <li class="mb-2">
            人の生命、身体または財産の保護のために必要があり、さらに利用者の同意を得るのが困難な場合
          </li>
          <li class="mb-2">
            その他、個人情報保護法その他の法令で認められる場合
          </li>
        </ol>
      </div>
      <div class="mb-10">
        <h3 class="co-display-11 mb-5 font-bold">
          個人情報の安全管理について
        </h3>
        <ol class="my-5 ml-4 list-decimal pl-7">
          <li class="mb-2">
            当社では、個人情報の漏洩または毀損の防止ならびにその他個人情報の安全管理が行われるよう、個人情報の適切な管理を行います。
          </li>
          <li class="mb-2">
            当社では、業務遂行に必要な範囲内で、権限を与えられた者のみが個人情報を取り扱います。
          </li>
        </ol>
      </div>
      <div class="mb-10">
        <h3 class="co-display-11 mb-5 font-bold">
          個人情報の開示、訂正、削除について
        </h3>
        <p class="mb-4 ml-4 leading-loose">
          個人情報の開示、訂正、削除について当社は、個人情報保護法その他の法令等に基づき、個人情報の開示、訂正、追加、削除、利用停止、消去、第三者提供の停止、利用目的の通知の請求に対応いたします。請求が本人確認不可能な場合や、個人情報保護法の定める要件を満たさない場合、ご希望に添えない場合があります。 なお、アクセスログなどの個人情報以外の情報については、原則として開示等はいたしません。<br>なお、開示等の請求に関する手数料として１回の申請ごとに500円を頂戴いたします。500円分の郵便切手を請求書類に同封して下さい。（利用停止・訂正等については手数料は不要です。）
        </p>
      </div>
      <div class="mb-10">
        <h3 class="co-display-11 mb-5 font-bold">
          プライバシーポリシーの更新について
        </h3>
        <p class="mb-4 ml-4 leading-loose">
          当社は、個人情報保護を図るため、法令等の変更や必要に応じて、本プライバシーポリシーを改訂することがあります。その際は、最新のプライバシーポリシーを本サービスに掲載いたします。本ページを都度ご確認の上、本サービスのプライバシーポリシーをご理解いただくようお願いします。
        </p>
      </div>
      <div class="mb-10">
        <h3 class="co-display-11 mb-5 font-bold">
          プライバシーポリシーに関するお問い合わせ
        </h3>
        <p class="mb-4 ml-4 leading-loose">
          当社は、個人情報保護を図るため、法令等の変更や必要に応じて、本プライバシーポリシーを改訂することがあります。その際は、最新のプライバシーポリシーを本サービスに掲載いたします。本ページを都度ご確認の上、本サービスのプライバシーポリシーをご理解いただくようお願いします。
        </p>
        <p class="mb-4 ml-4 leading-loose">
          〒150-0002<br>東京都渋谷区渋谷一丁目2番5号<br>株式会社ブリューアス 個人情報管理責任者 宛
        </p>
      </div>
      <p class="text-right leading-loose">
        2012年10月30日制定<br>
        2013年9月24日改定<br>
        2015年3月1日改訂<br>
        2016年7月7日改定<br>
        2022年3月31日改訂<br>
        2023年10月2日改訂<br>
        2023年10月11日改訂
      </p>
    </div>
  </div>
</template>

<style scoped>
@import url('~/assets/css/YaTe/YaTeCommon/YaTeCommon.css');
</style>
